var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReload = function SvgReload(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M940.4 560.3c0 242.7-198.3 439.5-440.9 439.5-244.1-1.4-440.9-198.3-440.9-439.5 0-218.9 167.2-405.4 383.2-434.9 1.4-63.6 5.9-118.3 13.3-124.2L461-.2c28.1 0 281.2 159.7 282.5 190.8 0 4.4-3 10.3-11.9 19.2-44.4 44.4-238.2 171.6-269.3 171.6l-4.4-1.4c-4.4-3-8.9-8.9-13.3-54.7-1.4-17.8-3-44.4-3-73.9-148 27.7-257.4 156.5-257.4 307.5 0 173.2 142.1 315 316.6 315s316.6-140.5 316.6-315c0-34.1 28.1-62.2 62.2-62.2 32.6 1.6 60.8 29.5 60.8 63.6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReload);
export default ForwardRef;